import { render, staticRenderFns } from "./CommunityHappinessAnnualRankingTable.vue?vue&type=template&id=18f58ba6&scoped=true&"
import script from "./CommunityHappinessAnnualRankingTable.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessAnnualRankingTable.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHappinessAnnualRankingTable.vue?vue&type=style&index=0&id=18f58ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f58ba6",
  null
  
)

export default component.exports